export { PLUGIN_KEY, PLUGIN_PRIORITY, NestedHeaders } from "./nestedHeaders.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/nestedHeaders/index.mjs
// module id = 1506
// module chunks = 1